import { refreshtokensQuery } from "../../graphql/queries";
import { RefreshTokenMutation, RefreshTokenMutationVariables } from "../../graphql/types";
import { ConcurrentEntryGuard } from "../utils";
import { fetchGraphql } from "./graphqlClient";

export const getRefreshToken = () => localStorage.getItem("refreshToken");
export const getAccessToken = () => localStorage.getItem("accessToken");
export const setRefreshToken = (token: string) => localStorage.setItem("refreshToken", token);
export const setAccessToken = (token: string) => localStorage.setItem("accessToken", token);
export const removeTokens = () => {
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("accessToken");
}

const refreshTokenGuard = new ConcurrentEntryGuard<boolean>();

export function tryRefreshToken() {
    return refreshTokenGuard.call(async () => {
        const refreshToken = getRefreshToken();
        if (refreshToken) {
            const tokenResult = await fetchGraphql<RefreshTokenMutation, RefreshTokenMutationVariables>("RefreshToken", refreshtokensQuery, { token: refreshToken }, false);
            if (tokenResult?.data?.token?.accessToken) {
                setAccessToken(tokenResult.data.token.accessToken);
                if (tokenResult.data.token.refreshToken) {
                    setRefreshToken(tokenResult.data.token.refreshToken);
                }
                return true;
            }
        }
        return false;
    });
}
